import { render, staticRenderFns } from "./UpdateUserPage.vue?vue&type=template&id=df70e7c6"
import script from "./UpdateUserPage.vue?vue&type=script&lang=js"
export * from "./UpdateUserPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports